import type { Resource } from '@/db/types'
import { invalid } from '@/kinds/kind'
import { CIRCLES, keyOf, type PersonSpec, type PersonStatus } from './schema'

export type PersonResource = Resource<PersonSpec, PersonStatus>

/** The handle comes from the name when none is given (person.Kind.Defaults). */
export const defaults = (spec: Partial<PersonSpec>): PersonSpec => ({
  name: '',
  ...spec,
  key: spec.key || keyOf(spec.name ?? ''),
})

export const validate = (r: PersonResource): string[] => {
  const errs: string[] = []
  if (!r.spec.name.trim()) errs.push('a person needs a name')
  if (!/^[a-z0-9_-]{1,32}$/.test(r.spec.key)) errs.push('the handle is lowercase letters, digits, - and _')
  if (r.spec.circle && !CIRCLES.includes(r.spec.circle)) errs.push('unknown circle')
  return errs
}

export const initialStatus = (): PersonStatus => ({})

export const displayName = (r: PersonResource): string => r.spec.name

/** People have no actions: everything is a spec patch (mirrors internal/kinds/person). */
export const apply = (_r: PersonResource, action: string): PersonResource => {
  throw invalid(`unknown action ${action}`)
}
